<template>
  <div>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-5" flat>
              <v-icon>mdi-format-align-justify</v-icon>
              <v-toolbar-title class="toolbar-title-2">{{ labels.mainTitle }}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-data-table :headers="headers" :items="retention" class="elevation-1">
                      <template slot="no-data"> </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex lg6 xs6>
                    <v-text-field
                      v-int-mask="{ intScale: 3 }"
                      v-model="mainForm.grpRiskNo"
                      :label="labels.grpRiskNo"
                      type="tel"
                      :error-messages="errors.collect('grpRiskNo')"
                      data-vv-name="grpRiskNo"
                      :data-vv-as="labels.grpRiskNo"
                      v-validate="'required|numeric|max_value:999|min_value:1'"
                    ></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs6>
                    <v-text-field
                      v-int-mask="{ intScale: 3 }"
                      v-model="mainForm.ownRen"
                      :label="labels.ownRen"
                      type="tel"
                      :error-messages="errors.collect('ownRen')"
                      data-vv-name="ownRen"
                      :data-vv-as="labels.ownRen"
                      v-validate="'required|numeric|max_value:999|min_value:1'"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      labels: {
        mainTitle: 'Amend Retention Details',
        grpRiskNo: 'Group / Risk No.',
        ownRen: 'Own Retention'
      },
      mainForm: {},
      headers: [
        { text: 'Risk Group', align: 'left', value: 'riskGroup' },
        { text: 'Risk No', value: 'riskNo' },
        { text: 'Sum Insured', value: 'sumInsured' },
        { text: 'Own Retention', value: 'ownRetention' },
        { text: 'Coinsurance', value: 'coinsurance' },
        { text: 'Statutory', value: 'statutory' },
        { text: 'Facultative', value: 'fac' },
        { text: 'Treaty', value: 'treaty' },
        { text: 'Quota Share', value: 'quota' },
        { text: 'Net Retention', value: 'netRentention' }
      ],
      retention: []
    }
  }
}
</script>

<style>
</style>
